import React from 'react';

const LogViewerModal = ({ content, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
            <div className="bg-gray-900 text-white rounded-lg shadow-xl w-11/12 h-5/6 flex flex-col">
                <div className="p-4 border-b border-gray-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold">Firestore Debug Log</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-white">&times;</button>
                </div>
                <pre className="flex-grow p-4 overflow-auto text-xs whitespace-pre-wrap">
                    {content}
                </pre>
            </div>
        </div>
    );
};

export default LogViewerModal;
